<form 
        (ngSubmit)="$event.preventDefault(); saveAddition();"
        [formGroup]="additionForm"
        class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
    >
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Additional Information
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4">
            <div class="w-full flex flex-col items-start text-start" *ngFor="let question of questionList">
                <div class="w-full font-semibold">
                  <p>{{ question.question }}</p>
                </div>
                <div class="w-full flex items-start gap-2">
                  <div>
                    <input type="radio" *ngIf="question.formControlName" [id]="question.formControlName + '_yes'" value="{{ this.yesNo.Yes }}" class="hidden peer" [formControlName]="question.formControlName">
                    <label [for]="question.formControlName + '_yes'"
                      class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                      Yes
                    </label>
                  </div>
                  <div>
                    <input type="radio" *ngIf="question.formControlName" [id]="question.formControlName + '_no'" value="{{ this.yesNo.No }}" class="hidden peer" [formControlName]="question.formControlName">
                    <label [for]="question.formControlName + '_no'"
                      class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                      No
                    </label>
                  </div>
                  <div>
                    <input type="radio" *ngIf="question.formControlName" [id]="question.formControlName + '_need_more_info'" value="{{ this.yesNo.NeedMoreInfo }}" class="hidden peer" [formControlName]="question.formControlName">
                    <label [for]="question.formControlName + '_need_more_info'"
                      class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                      Need more information
                    </label>
                  </div>
                </div>
            </div>
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Describe additional circumstances that might increase the likelihood of violence like home stressors: (domestic violence, incarcerated family member, etc.)</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <textarea 
                        formControlName="stressful_events_information"
                        rows="3"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        placeholder=""
                    ></textarea>
                </div>
            </div> 
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Home stressors (What are some of the potential home stressors)?</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <textarea 
                        formControlName="home_stressors_information"
                        rows="3"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        placeholder=""
                    ></textarea>
                </div>
            </div>   
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.additionForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.additionForm.valid
                }"
                [disabled]="this.additionForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>